export default __webpack_public_path__ + "static/media/two.1e6cc37d.png";